export default __webpack_public_path__ + "static/media/information--general-speed-limit-at-city-border--g1.162d9f16.png";